import { render, staticRenderFns } from "./personalConsultDetail.vue?vue&type=template&id=2719745c&scoped=true"
import script from "./personalConsultDetail.vue?vue&type=script&lang=js"
export * from "./personalConsultDetail.vue?vue&type=script&lang=js"
import style0 from "./personalConsultDetail.vue?vue&type=style&index=0&id=2719745c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2719745c",
  null
  
)

export default component.exports